import {
  WebContentElementController,
  DataStateChangeEvent,
  WebContentType,
} from '@sas-dvr/ltjs-bird';
import { WebContentState } from '@sas-dvr/internal-va-react-core/store/birdElement/webContentState';
import { VisualElementControllerLoader } from './LoaderFactory';
import { map, filter, tap, ignoreElements, distinctUntilChanged } from 'rxjs/operators';
import { fromPortableEvent } from '../util';
import { EMPTY, merge } from 'rxjs';
import { getMaximizeObservables } from '../util/maximizeUtils';
import { loadDataVisualElementController } from './loadDataVisualElement';

export const loadWebContentElementController: VisualElementControllerLoader = (
  visualController,
  visualElementController,
  unload$,
  myActions$,
  state$,
  deps
) => {
  if (!(visualElementController instanceof WebContentElementController)) {
    throw new Error('Expected the controller to be a GraphElementController');
  }
  const model = visualElementController.getModel();
  if (!model) {
    throw new Error('Expected the WebContentElementController to have a model');
  }

  const id = deps.getKey(visualElementController);

  const getJsonData = () => {
    const jsonString = visualElementController.getJSONXData();
    if (jsonString) {
      try {
        return JSON.parse(jsonString);
      } catch (e) {
        console.error('Error parsing the JSON string: ' + jsonString, e);
      }
    }
  };

  return merge(
    //
    // VisualElement load
    //
    loadDataVisualElementController(
      visualController,
      visualElementController,
      unload$,
      myActions$,
      state$,
      deps,
      {
        create: () => {
          const jsonData = getJsonData();
          const resultName: string = jsonData ? jsonData.resultName : undefined;
          return WebContentState.actions.add(id, {
            src: model.getUrl() || '',
            messageDataPost: jsonData,
            resultName: resultName,
          });
        },
        delete: () => WebContentState.actions.delete(id),
      }
    ),
    fromPortableEvent(visualElementController, DataStateChangeEvent.DATACHANGE).pipe(
      map(() => {
        const jsonData = getJsonData();
        const resultName: string = jsonData ? jsonData.resultName : undefined;
        return WebContentState.actions.update(id, {
          messageDataPost: jsonData,
          resultName: resultName,
        });
      })
    ),
    state$.pipe(
      map((aState) => aState.birdElements.WebContent[id]),
      filter((myState): myState is Exclude<typeof myState, undefined> => myState !== undefined),
      map((myState) => myState.messageDataReceive),
      distinctUntilChanged(),
      tap((messageDataReceive) => {
        try {
          visualElementController.selectFromJSONX(JSON.stringify(messageDataReceive));
        } catch (e) {
          console.error('Error stringifying JSON data', e);
        }
      }),
      ignoreElements()
    ),
    visualElementController.getModel()?.getWebContentType() === WebContentType.WEBDATACONTENT
      ? getMaximizeObservables(id, visualController, visualElementController, state$, unload$)
      : EMPTY
  );
};
